"use client";
import React from "react";
import { motion } from "framer-motion";

const cardVariants = {
  offscreen: {
    opacity: 0,
    y: 50
  },
  onscreen: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      duration: 0.8,
      bounce: 0.3
    }
  }
};

const FeatureCard = ({ title, description, icon }) => (
  <motion.div
    initial="offscreen"
    whileInView="onscreen"
    viewport={{ once: true, amount: 0.5 }}  // Only animate when 50% visible
    variants={cardVariants}
    whileHover={{ translateY: -8 }}
    className="relative group"
  >
    <div className="bg-white p-8 rounded-2xl border border-gray-100 hover:border-blue-100 
      transition-all duration-300">
      <div className="bg-blue-50 w-12 h-12 rounded-2xl flex items-center justify-center mb-4
        transition-transform duration-300 group-hover:scale-110">
        <div className="text-blue-600">
          {icon}
        </div>
      </div>
     
      <h3 className="text-xl font-semibold mb-4 text-gray-900 transition-colors duration-300 
        group-hover:text-blue-600">
        {title}
      </h3>
     
      <p className="text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  </motion.div>
);

const Benefits = ({ title, description, features }) => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-white/70 to-transparent 
        pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ 
            opacity: 1, 
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1]
            }
          }}
          viewport={{ once: true, amount: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-4xl sm:text-6xl font-bold tracking-tighter mb-6">
            {title}
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
            {description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;